import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import {changeLoginAction, fsCreateAndMergeUserEmail, fsLoginEmail, fsResetEmailPassword} from "../../ducks/duck-user";
import {goBack} from "../../ducks/duck-router";

import InputForm from './input-form'
import LOGIN_EMAIL_ACTIONS from "../../constants/LOGIN_EMAIL_ACTIONS";

class InputFormContainer extends Component {
	state = {
		emailValue: '',
		passwordValue: '',
		repeatValue: '',

		emailError: '',
		passwordError: '',
		repeatError: '',

		isConnecting: false,
	};

	changeAction = (action) => {
		if(action === LOGIN_EMAIL_ACTIONS.LOGIN){
			this.props.goBack()
		} else {
			this.props.push(action);
		}
		this.props.changeLoginAction(action);

		// this.setState({action})
	};

	setIsConnecting = (isConnecting) => {
		this.setState({isConnecting})
	};

	emailOnChange = (e) => {
		this.setState({ emailValue: e.target.value});
		this.validateEmail(e);
	};

	passwordOnChange = (e) => {
		this.setState({ passwordValue: e.target.value });
		this.validatePassword(e.target.value);

		if(this.state.repeatValue){
			this.validateRepeat(this.state.repeatValue, e.target.value)
		}
	};

	repeatOnChange = (e) => {
		this.setState({ repeatValue: e.target.value });
		this.validateRepeat(e.target.value)
	};

	resetInputs = (keepEmail = false) => {
		if(!keepEmail) {
			this.setState({
				emailValue: ''
			})
		}
		this.setState({
			passwordValue: '',
			repeatValue: '',
			emailError: '',
			passwordError: '',
			repeatError: '',
			isConnecting: false
		});
	};

	validateEmail = (e) => {
		const email = e.target.value;

		if(email.indexOf('@') === -1){
			this.setState({ emailError: 'Invalid Email' })
		} else {
			this.setState({ emailError: '' })
		}

	};

	validatePassword = (password) => {
		if(password.length < 6){
			this.setState({ passwordError: 'Password too short' })
		} else {
			this.setState({ passwordError: '' })
		}
	};

	validateRepeat = (repeat, password="") => {
		if(!password){
			password = this.state.passwordValue
		}

		if(repeat !== password){
			this.setState({ repeatError: 'Passwords are different' })
		} else {
			this.setState({ repeatError: '' })
		}
	}

	buttonErrorCallback = (errorMessage) => {

		if(!errorMessage) {

			this.setState({
				isConnecting: false
			})

		}else if(errorMessage.type === "password"){

			this.setState({
				passwordError: errorMessage.message,
				isConnecting: false
			})

		} else if(errorMessage.type === "email") {

			this.setState({
				emailError: errorMessage.message,
				isConnecting: false
			})

		}

	}

	buttonSuccessCallback = (type) => {
		if(type === LOGIN_EMAIL_ACTIONS.LOGIN){
			this.props.goBack();
			this.props.goBack();
			this.props.goBack();
		} else if (type === LOGIN_EMAIL_ACTIONS.REGISTER) {
			this.props.goBack();
			this.props.goBack();
			this.props.goBack();
			this.props.goBack();
		} else {
			this.props.goBack();
			this.resetInputs(true)
		}
	};


	render(){

		const functions = {
			"changeAction": this.changeAction,
			"emailOnChange": this.emailOnChange,
			"passwordOnChange": this.passwordOnChange,
			"repeatOnChange": this.repeatOnChange,
			"resetInputs": this.resetInputs,
			"validateEmail": this.validateEmail,
			"buttonErrorCallback": this.buttonErrorCallback,
			"buttonSuccessCallback": this.buttonSuccessCallback,
			"setIsConnecting": this.setIsConnecting,
			"fsLoginEmail": this.props.fsLoginEmail,
			"fsCreateAndMergeUserEmail": this.props.fsCreateAndMergeUserEmail,
			"fsResetEmailPassword": this.props.fsResetEmailPassword,
		};

		const reduxState = {
			"loginAction": this.props.loginAction
		}

		const strings = {
			contactEmail: this.props.contactEmail,
			privacyPolicyUrl: this.props.privacyPolicyUrl
		}

		return(
				<InputForm
					{...functions}
					{...this.state}
					{...reduxState}
					{...strings}
				/>
		)
	}


}

InputFormContainer.propTypes = {
	contactEmail: PropTypes.string.isRequired,
	privacyPolicyUrl: PropTypes.string.isRequired,

	push: PropTypes.func.isRequired,
	fsLoginEmail: PropTypes.func.isRequired,
	fsCreateAndMergeUserEmail: PropTypes.func.isRequired,
	fsResetEmailPassword: PropTypes.func.isRequired,
	changeLoginAction: PropTypes.func.isRequired,
	goBack: PropTypes.func.isRequired
};

function mapStateToProps(state) {
	return {
		loginAction: state.userReducer.loginAction,
		privacyPolicyUrl: state.configReducer.appConfig.strings.privacyPolicyUrl,
		contactEmail: state.configReducer.appConfig.contactEmail
	};
}

export default connect(mapStateToProps, {
	fsLoginEmail,
	fsCreateAndMergeUserEmail,
	fsResetEmailPassword,
	changeLoginAction,
	goBack
})(InputFormContainer);